module.exports = __webpack_public_path__ + "static/media/matte-art-paper.a7c115c4.jpg";